import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { MOBILE_BREAKPOINT, useIsMobile } from 'common/hooks/useIsMobile';

import CampaignFormItemLayout, { CampaignFormItemLayoutProps } from './CampaignFormItemLayout';

type CampaignFormItemProps = CampaignFormItemLayoutProps & {
  banner?: ReactNode;
  children?: ReactNode;
  'data-test-id'?: string;
};

const CampaignFormItemContainer = styled.div<{ hasBanner: boolean }>`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 0 auto;
  border: 1px solid;
  border-color: ${cbSemanticCssVars.borderPrimary};
  border-radius: 8px;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const StyledActionWrapper = styled.div`
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    display: flex;
    width: 100%;
    padding-inline: 16px;
    padding-block: 8px 16px;

    > * {
      flex: 1;
    }
  }
`;

const CampaignFormViewLayout = styled(CampaignFormItemLayout)`
  padding: 16px;
`;

const CampaignFormView = ({ title, subtitle, action, tooltip, banner, value }: CampaignFormItemProps) => {
  const content = (
    <CampaignFormViewLayout title={title} subtitle={subtitle} action={action} tooltip={tooltip} value={value} />
  );

  return !!banner ? (
    <div>
      {banner}
      {content}
    </div>
  ) : (
    content
  );
};

const CampaignFormItem = ({
  title,
  subtitle,
  tooltip,
  value,
  action,
  banner,
  children,
  ...props
}: CampaignFormItemProps) => {
  const isMobile = useIsMobile();
  const hasBanner = !!banner;
  const actionElement = action && <StyledActionWrapper>{action}</StyledActionWrapper>;
  return (
    <CampaignFormItemContainer data-test-id={props['data-test-id']} hasBanner={hasBanner}>
      <CampaignFormView
        title={title}
        tooltip={tooltip}
        value={value}
        subtitle={subtitle}
        banner={banner}
        action={!isMobile && actionElement}
      />
      {isMobile && actionElement}
      {children}
    </CampaignFormItemContainer>
  );
};

export default CampaignFormItem;
